module.exports = __webpack_public_path__ + "assets/img/reminder-detail-4.f4f7a1a2.png";